export default __webpack_public_path__ + "static/media/redux.3863bd1d.png";